import TagList from './TagList';

export * from './TagList';

export default TagList;
